<template>
  <v-layout v-resize="getWindowDimensions">
    <div
      v-if="isLoading"
      class="d-flex justify-center align-center"
      style="height: 100vh; width: 100vw;"
    >
      <v-progress-circular
        indeterminate
        color="#2661FF"
        size="80"
      ></v-progress-circular>
    </div>
    <div v-else style="width: 100%;">
      <v-row no-gutters>
        <v-col cols="12">
          <BaseToolbar
            :title="organizationLocal.name"
            type-title="icon"
            icon="business"
            :button-save="false"
            :options="[
              {
                text: this.$t('general.edit'),
                name: 'edit',
                show: true
              },
              {
                text: this.$t('organization.options.createUser'),
                name: 'create',
                show: true
              }
            ]"
            @edit="edit"
            @create="create"
            @close="closeOrganizationDrawer"
          >
            <div class="pa-4">
              <v-dialog
                v-model="removeOrganizationDialog.display"
                width="700"
                persistent
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="#2661FF"
                    small
                    class="rounded-lg"
                  >
                    <span class="white--text">
                      {{ $t('organization.remove') }}
                    </span>
                  </v-btn>
                </template>
                <v-card
                  class="rounded-lg custom_card"
                  flat
                  style="position: relative; overflow-y: hidden;"
                >
                  <v-card-title class="justify-center">
                    <span class="ml-2">
                      {{ $t('organization.remove') }}
                    </span>
                    <v-btn
                      icon
                      style="position: absolute; top: 15px; right: 15px;"
                      @click="closeRemoveOrganizationDialog"
                    >
                      <v-icon>
                        close
                      </v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-divider />
                  <v-card-text>
                    <v-row class="my-2">
                      <v-col
                        cols="12"
                        class="d-flex justify-center align-center"
                      >
                        <v-icon size="34" class="grey--text text--darken-3">
                          domain
                        </v-icon>
                      </v-col>
                      <v-col
                        cols="12"
                        class="d-flex justify-center align-center"
                      >
                        <span
                          class="grey--text text--darken-3 font-weight-medium"
                          style="font-size: 20px;"
                        >
                          {{ organization.name }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-divider v-if="removeOrganizationDialog.readConsequences" />
                  <v-card-text
                    v-if="
                      removeOrganizationDialog.readConsequences ||
                        removeOrganizationDialog.confirmConsequences
                    "
                  >
                    <v-row>
                      <v-col cols="12" class="my-2">
                        <v-alert text type="warning">
                          <span class="body-2">
                            ¡Cosas malas inesperadas sucederán si no lees esto!
                          </span>
                        </v-alert>
                      </v-col>
                      <v-col cols="12">
                        <v-timeline dense>
                          <v-timeline-item color="#2661FF" small>
                            Esta acción eliminará permanentemente la
                            organización
                            <span
                              class="font-weight-medium"
                              style="color: #2661FF"
                            >
                              {{ organization.name }} </span
                            >. Esto resultará en la deshabilitación de todas sus
                            secuencias, campañas, formularios, newsletters,
                            integraciones, pasarelas de pagos y landings.
                          </v-timeline-item>
                          <v-timeline-item color="#2661FF" small>
                            Además, todos los leads y la información sensible de
                            las transacciones relacionadas serán anonimizados.
                          </v-timeline-item>
                        </v-timeline>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-divider />
                  <v-card-actions>
                    <v-row
                      v-if="
                        !removeOrganizationDialog.readConsequences &&
                          !removeOrganizationDialog.confirmConsequences
                      "
                    >
                      <v-col cols="12" class="my-1">
                        <v-btn
                          @click="
                            removeOrganizationDialog.readConsequences = true
                          "
                          class="rounded-lg"
                          block
                          color="#2661FF"
                        >
                          <span class="white--text">
                            Deseo eliminar esta organización
                          </span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row
                      v-else-if="removeOrganizationDialog.readConsequences"
                    >
                      <v-col cols="12" class="my-1">
                        <v-btn
                          @click="confirmConsequences"
                          class="rounded-lg"
                          block
                          color="#2661FF"
                        >
                          <span class="white--text">
                            He leido y comprendo las consecuencias
                          </span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row
                      v-else-if="removeOrganizationDialog.confirmConsequences"
                    >
                      <!------------------------------------------>
                      <!-- DELETE TYPE ----------------------------->
                      <!------------------------------------------>
                      <v-col
                        cols="12"
                        class="d-flex justify-center align-center"
                      >
                        <v-radio-group
                          v-model="removeOrganizationDialog.removeType"
                          row
                        >
                          <v-radio
                            label="Instantáneo"
                            :value="1"
                            color="#2661FF"
                          ></v-radio>
                          <v-radio
                            label="Programado"
                            :value="2"
                            color="#2661FF"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>

                      <v-col cols="12">
                        <v-form ref="schedule_remove_org_form">
                          <v-row>
                            <!------------------------------------------>
                            <!-- SCHEDULE ----------------------------->
                            <!------------------------------------------>
                            <v-col
                              v-if="removeOrganizationDialog.removeType === 2"
                              cols="12"
                            >
                              <v-menu
                                v-model="removeOrganizationDialog.scheduleMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="removeOrganizationDialog.date"
                                    v-bind="attrs"
                                    v-on="on"
                                    :rules="removeOrganizationDialog.rules.date"
                                    label="Programar fecha de eliminación"
                                    prepend-inner-icon="calendar_month"
                                    readonly
                                    class="rounded-lg"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="removeOrganizationDialog.date"
                                  @input="
                                    removeOrganizationDialog.scheduleMenu = false
                                  "
                                  :min="removeOrganizationDialog.minDate"
                                  color="#2661FF"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                            <!------------------------------------------>
                            <!-- CONFIRMATION ----------------------------->
                            <!------------------------------------------>
                            <v-col cols="12">
                              <label
                                for="removeConfirmOrganization"
                                class="caption"
                              >
                                Para confirmar la eliminación de la
                                organización, escribe el nombre de la
                                organización:
                                <span
                                  style="color:#2661FF;"
                                  class="font-weight-medium"
                                >
                                  {{ organization.name }}
                                </span>
                              </label>
                              <v-text-field
                                id="removeConfirmOrganization"
                                v-model="
                                  removeOrganizationDialog.confirmValidation
                                "
                                :rules="
                                  removeOrganizationDialog.rules
                                    .confirmValidation
                                "
                                class="rounded-lg"
                                dense
                                outlined
                              />
                            </v-col>
                            <v-col cols="12">
                              <v-btn
                                @click="confirmRemoveOrganization"
                                :loading="removeOrganizationDialog.loading"
                                class="rounded-lg"
                                block
                                color="#2661FF"
                              >
                                <span class="white--text">
                                  {{ $t('organization.remove') }}
                                </span>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>

            <v-menu
              offset-y
              bottom
              nudge-bottom="12px"
              min-width="150px"
              style="z-index: 20;"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  ref="button-open-menu-status"
                  v-on="on"
                  :color="getStatusObject(organization.status).color"
                  width="150"
                  text
                  small
                >
                  <v-icon
                    v-text="getStatusObject(organization.status).icon"
                    size="20"
                    class="mr-1"
                  />
                  <div>
                    {{ getStatusObject(organization.status).text }}
                  </div>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  v-for="status in computedStatusOptions"
                  :disabled="status.disabled"
                  :key="status.name"
                  class="cursor-pointer"
                >
                  <v-list-item-title
                    class="text-uppercase"
                    :class="`${getStatusObject(status.name).color}--text`"
                    @click="changeStatus(status.name)"
                  >
                    <v-icon
                      v-text="getStatusObject(status.name).icon"
                      :color="getStatusObject(status.name).color"
                      size="20"
                      class="mr-1"
                    />
                    {{ getStatusObject(status.name).text }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </BaseToolbar>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <v-card class="pt-10" flat>
            <v-tabs
              v-model="activeTab"
              centered
              color="#2661FF"
              slider-color="#2661FF"
            >
              <v-tab v-for="(tab, index) in tabs" :key="index">
                {{ tab.title }}
              </v-tab>
            </v-tabs>
          </v-card>
          <v-tabs-items v-model="activeTab">
            <v-tab-item v-for="(tab, index) in tabs" :key="index">
              <component
                :is="tab.component"
                class="grey lighten-4"
                v-if="orgId"
              ></component>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </div>
  </v-layout>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import Dashboard from '@/components/Organization/Details/Dashboard'
import Features from '@/components/Organization/Features/Features'
import Settings from '@/components/Organization/Settings/Settings'
import organizationMixin from '@/mixins/organization'
import BaseToolbar from '@/components/BaseToolbar'

export default {
  name: 'OrganizationDetails',
  components: { BaseToolbar, Dashboard, Features, Settings },
  mixins: [organizationMixin],
  data() {
    return {
      isLoading: false,
      organizationLocal: {},
      activeTab: null,
      tabs: [
        { title: this.$t('organization.dashboard'), component: 'Dashboard' },
        {
          title: this.$t('organization.required_actions'),
          component: 'Features'
        },
        { title: this.$t('organization.settings'), component: 'Settings' }
      ],
      removeOrganizationDialog: {
        loading: false,
        display: false,
        readConsequences: false,
        confirmConsequences: false,
        removeType: 1,
        scheduleMenu: false,
        date: null,
        confirmValidation: '',
        rules: {
          date: [
            v => !!v || 'La fecha es requerida',
            v => v >= this.$moment().format('YYYY-MM-DD') || 'Fecha inválida'
          ],
          confirmValidation: [
            v => !!v || 'Debes confirmar la eliminación de la organización',
            v =>
              v === this.organization.name ||
              'El valor ingresado debe ser igual al nombre de la organización'
          ]
        },
        minDate: this.$moment()
          .add(1, 'day')
          .startOf('day')
          .format('YYYY-MM-DD')
      }
    }
  },
  watch: {
    // Get Organization
    async orgId(newVal, oldVal) {
      if (newVal) {
        this.isLoading = true
        await this.getOrganization(newVal)
      }
    },
    async organization(newVal, oldVal) {
      if (newVal.id) {
        this.isLoading = false
        this.organizationLocal = JSON.parse(JSON.stringify(newVal))
        await this.getOrganizationPlan({
          organization_id: this.organization.id
        })
        await this.getWarningPayment({
          organization_id: this.organization.id
        })
      }
    },
    removeOrganizationDialog: {
      deep: true,
      handler() {
        const INSTANT = 1

        if (
          this.removeOrganizationDialog.confirmConsequences &&
          this.removeOrganizationDialog.removeType === INSTANT
        ) {
          this.removeOrganizationDialog.date = null
        }
      }
    }
  },
  computed: {
    ...mapState({
      orgId: ({ organization: { orgId } }) => orgId,
      organization: ({ organization: { organization } }) => organization
    }),
    computedStatusOptions() {
      const DELETED = 'deleted'

      return this.status_options.map(option => {
        if (option === DELETED) {
          return {
            name: option,
            disabled: true
          }
        }
        return { name: option, disabled: false }
      })
    }
  },
  methods: {
    ...mapActions({
      getOrganization: 'organization/getOrganization',
      getWarningPayment: 'organization/getWarningPayment',
      removeOrganization: 'organization/removeOrganization',
      getOrganizationPlan: 'organization/getOrganizationPlan'
    }),
    ...mapMutations({
      setOrgId: 'organization/setOrgId',
      setOrgMembers: 'organization/setOrgMembers',
      setOrgCampaigns: 'organization/setOrgCampaigns',
      setOrgFormsLeads: 'organization/setOrgFormsLeads',
      setWarningPayment: 'organization/setWarningPayment',
      organizationDrawer: 'organization/organizationDrawer',
      changeOrganization: 'organization/changeOrganization',
      setOrganizationPlan: 'organization/setOrganizationPlan',
      setOrgFormsDonations: 'organization/setOrgFormsDonations',
      organizationDrawerEdit: 'organization/organizationDrawerEdit',
      changeOrganizationUser: 'organization/changeOrganizationUser',
      organizationDrawerUser: 'organization/organizationDrawerUser',
      setOrganizationModules: 'organization/setOrganizationModules',
      closeOrganizationPlanDetail: 'organization/closeOrganizationPlanDetail',
      setOrganizationIntegrations: 'organization/setOrganizationIntegrations',
      setOrganizationAvaliableAddons:
        'organization/setOrganizationAvaliableAddons'
    }),
    getWindowDimensions() {
      if (process.client) {
        this.height = window.innerHeight - 65
        this.width =
          window.innerWidth > 800 ? window.innerWidth * 0.5 : window.innerWidth
      }
    },
    closeRemoveOrganizationDialog() {
      this.removeOrganizationDialog.display = false
      this.removeOrganizationDialog.readConsequences = false
      this.removeOrganizationDialog.confirmConsequences = false
    },
    confirmConsequences() {
      this.removeOrganizationDialog.readConsequences = false
      this.removeOrganizationDialog.confirmConsequences = true
    },
    // Remove organization
    async confirmRemoveOrganization() {
      const { organization, removeOrganizationDialog } = this
      const { date } = removeOrganizationDialog
      const { id: organization_id } = organization

      const valid = await this.$refs.schedule_remove_org_form.validate()

      if (!valid) {
        return this.$noty.error('Verifique los campos')
      }

      removeOrganizationDialog.loading = true

      await this.removeOrganization({ organization_id, date })

      removeOrganizationDialog.loading = false
    },
    // Edit organization
    edit() {
      this.organizationDrawerEdit(true)
    },
    // Create user
    create() {
      this.organizationDrawerUser({ type: 'new', value: true })
    },
    closeOrganizationDrawer() {
      /* GLOBAL */
      this.organizationLocal = {}
      this.setOrgId(null)
      this.changeOrganization({})
      /* DRAWERS */
      this.organizationDrawer(false)
      this.organizationDrawerEdit(false)
      this.organizationDrawerUser({ type: '', value: false })
      /* DASHBOARD TAB */
      this.changeOrganizationUser({})
      this.closeOrganizationPlanDetail()
      this.setOrgMembers([])
      this.setOrgCampaigns([])
      this.setOrgFormsLeads([])
      this.setOrgFormsDonations([])
      this.setOrganizationPlan({})
      /* FEATURE TAB */
      this.setWarningPayment({
        warning: null,
        warning_options: { permanent: false }
      })
      /* SETTINGS TAB */
      this.setOrganizationModules([])
      this.setOrganizationIntegrations([])
      this.setOrganizationAvaliableAddons([])
    }
  }
}
</script>

<style lang="scss" scoped>
.custom_card {
  border-radius: 12px !important;
  border: 1px solid #d0d3db !important;
}
</style>
